/* Sekcje sn-*: menu, wybór wariantu, galeria, ilość, pasek zakupu. */
(function () {
  'use strict';
  var doc = document;

  /* ---------- Menu na telefonie ---------- */
  function initNav() {
    var burger = doc.querySelector('[data-sn-burger]');
    var nav = doc.querySelector('[data-sn-nav]');
    if (!burger || !nav || burger.dataset.ready) return;
    burger.dataset.ready = '1';
    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    burger.addEventListener('click', function () {
      setOpen(burger.getAttribute('aria-expanded') !== 'true');
    });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  /* ---------- Sekcja zakupu ---------- */
  function initBuy(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var q = function (s) { return root.querySelector(s); };
    var dataEl = q('[data-sn-variants]');
    var variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { variants = []; }

    var idInput = q('[data-sn-variant-id]');
    var priceEl = q('[data-sn-price]');
    var stickyPrice = q('[data-sn-sticky-price]');
    var stock = q('[data-sn-stock]');
    var addBtn = q('[data-sn-add]');
    var stickyAdd = q('[data-sn-sticky-add]');
    var live = q('[data-sn-live]');
    var mainImg = q('.sn-gallery__img');
    var thumbs = root.querySelectorAll('[data-sn-thumb]');
    var optionInputs = root.querySelectorAll('[data-sn-option]');
    var contents = root.querySelectorAll('[data-sn-contents]');

    function showMedia(btn) {
      if (!btn || !mainImg) return;
      mainImg.src = btn.dataset.src;
      mainImg.removeAttribute('srcset');
      mainImg.alt = btn.dataset.alt || '';
      thumbs.forEach(function (t) {
        var on = t === btn;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t); });
    });

    function selectedOptions() {
      var sel = [];
      optionInputs.forEach(function (input) {
        if (input.checked) sel[parseInt(input.dataset.snOption, 10)] = input.value;
      });
      return sel;
    }

    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== undefined && v.options[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function updateContents(v) {
      if (!contents.length) return;
      var key = v ? String(v.title).trim().toLowerCase() : '';
      var specific = false;
      contents.forEach(function (c) { if (c.dataset.snContents && c.dataset.snContents === key) specific = true; });
      contents.forEach(function (c) {
        var k = c.dataset.snContents;
        c.hidden = specific ? k !== key : k !== '';
      });
    }

    function markAvailability(sel) {
      optionInputs.forEach(function (input) {
        var idx = parseInt(input.dataset.snOption, 10);
        var test = sel.slice();
        test[idx] = input.value;
        var v = findVariant(test);
        input.closest('.sn-chip').classList.toggle('is-unavailable', !v || !v.available);
      });
    }

    function apply(announce) {
      var sel = selectedOptions();
      var v = variants.length === 1 ? variants[0] : findVariant(sel);
      optionInputs.forEach(function (input) {
        if (!input.checked) return;
        var label = root.querySelector('[data-sn-option-value="' + input.dataset.snOption + '"]');
        if (label) label.textContent = input.dataset.label || input.value;
      });
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Wybierz inny wariant'; }
        if (stickyAdd) stickyAdd.disabled = true;
        if (stock) { stock.textContent = 'Ta kombinacja jest niedostępna'; stock.classList.add('is-out'); }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (stock) {
        stock.textContent = v.available ? stock.dataset.in : stock.dataset.out;
        stock.classList.toggle('is-out', !v.available);
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelOut;
      }
      if (stickyAdd) stickyAdd.disabled = !v.available;
      if (v.media) {
        var t = root.querySelector('[data-sn-thumb][data-media-id="' + v.media + '"]');
        if (t) showMedia(t);
      }
      updateContents(v);
      markAvailability(sel);
      if (announce && live) {
        var names = [];
        optionInputs.forEach(function (input) { if (input.checked) names.push(input.dataset.label || input.value); });
        live.textContent = 'Wybrano: ' + (names.join(', ') || v.title) + ', ' + v.price;
      }
      if (window.history && window.history.replaceState && variants.length > 1) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () { apply(true); });
    });
    apply(false);

    /* Ilość */
    var qty = q('[data-sn-qty-input]');
    root.querySelectorAll('[data-sn-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qty) return;
        var val = (parseInt(qty.value, 10) || 1) + parseInt(btn.dataset.snQty, 10);
        qty.value = Math.max(1, Math.min(20, val));
      });
    });

    /* Stan przycisku podczas dodawania */
    var form = q('[data-sn-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (addBtn && addBtn.disabled) { e.preventDefault(); return; }
        if (addBtn) { addBtn.setAttribute('aria-busy', 'true'); addBtn.textContent = 'Dodawanie…'; }
      });
    }

    /* Pasek zakupu: pokazuje się, gdy przycisk „Dodaj do koszyka” zniknie z ekranu */
    var sticky = q('[data-sn-sticky]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      var footer = doc.querySelector('.sn-footer');
      var addVisible = true, footerVisible = false, passed = false;
      function render() {
        var show = !addVisible && passed && !footerVisible;
        sticky.classList.toggle('is-visible', show);
        doc.body.classList.toggle('sn-has-sticky', show);
      }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          addVisible = en.isIntersecting;
          passed = en.boundingClientRect.top < 0;
        });
        render();
      }).observe(addBtn);
      if (footer) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { footerVisible = en.isIntersecting; });
          render();
        }).observe(footer);
      }
    }
  }

  function initAll(scope) {
    initNav();
    (scope || doc).querySelectorAll('[data-sn-buy]').forEach(initBuy);
  }

  doc.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { initAll(doc); });
  else initAll(doc);
})();
